@if (activeDepositCurfew) {
    <show-message [type]="messageType.INFO">
        <div info>
            <span>{{ 'PARTY.CASHIER.web.deposit.curfew.new.message1' | translate }}</span>
            <a href="{{ depositCurfewRedirectUrl }}" target="_top" class="ml-1">{{ 'PARTY.CASHIER.web.deposit.curfew.new.message2' | translate }}</a>
        </div>
    </show-message>
}
<app-ada-message />
<app-play-break-message />
<app-arc-message />
<app-pl-verification-message />
<app-rev-notification />
<app-session-limits />
@if (isEsRiskPlayer) {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.deposit.risk.player.message' | translate }}</strong>
            <a (click)="liveChatUrlRisky()">
                <span class="float-right">
                    <b>
                        {{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.liveChat' | translate }}
                    </b>
                </span>
            </a>
        </div>
    </show-message>
}
@if (depositService.showVATTaxMessage()) {
    @if (showVATInfoMessage()) {
        <show-message [type]="messageType.INFO" [showClose]="true" (close)="closeToaster()" class="vat-info_message">
            <div info>
                <p [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.vatTaxInfo.text2' | translate"></p>
            </div>
        </show-message>
    } @else {
        <show-message [type]="messageType.WARNING">
            <div warning>
                <p [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.vatTaxInfo.text' | translate"></p>
            </div>
        </show-message>
    }
}
